import React, { useState, useEffect } from "react";
import { YhMultiSelect } from "@/components/YhMultiSelect"
import { useDiscernModel } from "../discernModel";
import { addressSeries, dataSourceSeries, timeSeries, keyWordsSeries, isTakePartSeries, noticeSeries, isStatusSeries ,pubTimeSeries} from "../seriesData";
import { IDiscernSeachFields } from "../discernService";
import { ISearchSeriesType } from "@/views/filtration/view/PageHeader";
import { webSiteService } from "@/views/webSite/webSiteService";
import useGlobalModel from "@/model/globalModel";
import { keyWordsService } from "@/views/keyWords/keyWordsService";


export function PageHeader() {
	const {
		searchParam,
		setSearchParam,
		loadData,
		showOne, setShowOne
	} = useDiscernModel();
	const { address } = useGlobalModel();
	const [sourceSeries, setSourceSeries] = useState<ISearchSeriesType[]>([{ "title": "全部", "value": "", "active": true }]);
	const [keyWordSeries, setKeyWordSeries] = useState<ISearchSeriesType[]>([{ "title": "全部", "value": "", "active": true }]);

	const getSeriesDs = async () => {
		let { retData } = await webSiteService.page({ pageNum: 1, pageSize: -1 });
		let { records } = retData;
		retData && setSourceSeries((origin) => {
			let currentArr = records.map(item => ({
				"title": item.name ?? "",    // "天津",
				"value": item.id ?? "",    // "2",
				"active": false,    // false
			}))
			return [...origin, ...currentArr];
		});
		let { retData: ret } = await keyWordsService.page({ pageNum: 1, pageSize: 50 });
		let { records: res } = ret;
		res && setKeyWordSeries((origin) => {
			let currentArr = res.map(item => ({
				"title": item.name ?? "",    // "天津",
				"value": item.id ?? "",    // "2",
				"active": false,    // false
			}))
			return [...origin, ...currentArr];
		});
	}

	useEffect(() => {
		getSeriesDs();
	}, []);

	const searchSeriesFields = [
		{
			field: "keywords",
			title: "关键词",
			typeList: keyWordSeries
		},
		{
			field: "region",
			title: "地区",
			typeList: address
		},
		{
			field: "sourceFrom",
			title: "数据来源",
			typeList: sourceSeries
		},
		{
			field: "date",
			title: "截止日期",
			typeList: timeSeries
		},
		{
			field: "isJoin",
			title: "是否参与",
			typeList: isTakePartSeries
		},
		// {
		// 	field: "status",
		// 	title: "是否标注",
		// 	typeList: isStatusSeries
		// },
		{
			field: "noticeType",
			title: "公告类型",
			typeList: noticeSeries
		},
		{
			field: "pubDate",
			title: "采集日期",
			typeList: pubTimeSeries
		}
	]

	const handleShowOne = () => {
		setShowOne(origin => !origin);
	}
	return (
		<YhMultiSelect
			seriesDataSaurce={searchSeriesFields}
			filterFields={searchParam}
			setFilterFields={setSearchParam}
			onChange={(obj: IDiscernSeachFields) => loadData({ pageNum: 1 }, obj)}
			isShowOne={showOne}
			handleShowOne={handleShowOne}
		// onChange={(obj: IDiscernSeachFields) => { console.log(obj) }}
		/>
	);
}